function App() {
  return (
    <div>
      <h2>Treble App coming soon...</h2>
    </div>
  );
}

export default App;
